export default {
    "ๅ":"1",
    "/":"2",
    "-":"3",
    "ภ":"4",
    "ถ":"5",
     "ุ":"6",
     "ึ":"7",
    "ค":"8",
    "ต":"9",
    "จ":"0",
    
    "ๆ":"q",
    "ไ":"w",
    "ำ":"e",
    "พ":"r",
    "ะ":"t",
    "ั":"y",
    "ี":"u",
    "ร":"i",
    "น":"o",
    "ย":"p",
    "บ":"[",
    "ล":"]",
    "ฃ":"\\",
    "ฟ":"a",
    "ห":"s",
    "ก":"d",
    "ด":"f",
    "เ":"g",
    "้":"h",
    "่":"j",
    "า":"k",
    "ส":"l",
    "ว":";",
    "ง":"'",
    "ผ":"z",
    "ป":"x",
    "แ":"c",
    "อ":"v",
    "ิ":"b",
    "ื":"n",
    "ท":"m",
    "ม":",",
    "ใ":".",
    "ฝ":"/",

    "+":"!",
    "๑":"@",
    "๒":"#",
    "๓":"$",
    "๔":"%",
    "ู":"^",
    "฿":"&",
    "๕":"*",
    "๖":"(",
    "๗":")",
    "๘":"_",
    "๙":"+",

    "๐":"Q",
    '"':"W",
    "ฎ":"E",
    "ฑ":"R",
    "ธ":"T",
    "ํ":"Y",
    "๊":"U",
    "ณ":"I",
    "ฯ":"O",
    "ญ":"P",
    "ฐ":"[",
    ",":"]",
    "ฅ":"\\",

    "ฤ":"A",
    'ฆ':"S",
    "ฏ":"D",
    "โ":"F",
    "ฌ":"G",
    "็":"H",
    "๋":"J",
    "ษ":"K",
    "ศ":"L",
    "ซ":";",
    ".":"'",

    "(":"Z",
    ')':"X",
    "ฉ":"C",
    "ฮ":"V",
    "ฺ":"B",
    "์":"N",
    "?":"M",
    "ฒ":",",
    "ฬ":".",
    "ฦ":"/",
};